module.exports = __webpack_public_path__ + "media/images/img-pb-lite+-1a33afc7c530c9bf059dc134727ee9ba.png";